var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailDownloadLine = function SvgMailDownloadLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.7 7.715-7.135 6.39L5.3 7.695V18.3h8.1v1.8h-9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9V12h-1.8zM19.25 5.7H5.76l6.795 5.996L19.252 5.7zm.45 11.7h2.7L18.8 21l-3.6-3.6h2.7v-3.6h1.8z"
  })));
};
export default SvgMailDownloadLine;